import { AlignmentType, BorderStyle, Document, Footer, Header, HeadingLevel, HeightRule, ImageRun, LevelFormat, Packer, PageNumber, PageOrientation, Paragraph, SectionType, ShadingType, TabStopType, Table, TableCell, TableLayoutType, TableOfContents, TableRow, TextDirection, TextRun, VerticalAlign, WidthType, convertInchesToTwip } from "docx";
import { saveAs } from "file-saver";
import { auditReportTable, reportAppName } from "./Part1Audit/Page1Audit";
import { documentDistribution, documentHistory, documentPreparation, page2Heading } from "./Part1Audit/Page2Audit";
import { TOCHeadings } from "./Part1Audit/Page3Audit";
import { introductionBulletOne, introductionBulletThree, introductionBulletTwo, introductionText1 } from "./Part1Audit/Page4Audit";
import { scope } from "./Part1Audit/Page5Audit";
import { team } from "./Part1Audit/Page6Audit";
import { auditActivities, auditActivities1, auditPoint1, auditPoint2, auditPoint3, auditPoint4, auditPoint5, auditPoint6, auditPoint7, auditPoint8, auditPoint9, timeline1, timelines } from "./Part2Audit/Page7Audit";
import { Methodology, acclimatizePhase, acclimatizePhaseText, accrualPhase, accrualPhaseText, accrualPhasebullet1, accrualPhasebullet2, accrualPhasebullet3, admittancePhase, admittancePhaseText, affirmationPhase, affirmationPhaseText, analysisPhase, analysisPhaseText, auditMethodology } from "./Part2Audit/Page8Audit";
import { tools } from "./Part2Audit/Page9Audit";
import { SummaryRecommendation, cvssMapping, cvssMappingTable, determination, determination1, determination2, exploitation, exploitationTable, graphText, graphText1, recommendationBulletOne, recommendationBulletTwo, riskRating, riskRatingTable, severityLevelTable, sumaryText2, summaryText, summaryText1, summaryUserRoles, tableText, vulnerabilityTables } from "./Part2Audit/Page10Audit";
import { observation1, observation2, observation3 } from "./Part3Audit/Page11Audit";
import { complianceTable } from "./Part3Audit/Page12Audit";
import { appendicesTable, auditTools } from "./Part3Audit/Page13Audit";
import { url } from "../../../../constants/url";
import { toast } from "react-toastify";


export async function handleCertInAuditDownload(props) {

    const {
        certInReportName, certInApplicationName, certInDate, certInStartDate, certInEndDate,
        inchargeDesignation, inchargeEmail, inchargeName, certInCustomerName, certInApplicationUrl,
        certInAppDescription, criticality, certInAppEnvironment, certInTestingype, certInRoles,
        certInCritical, certInHigh, certInMedium, certInLow, certInInfo, certInVulnerabilities, setCertInDownloading, logout
    } = props

    setCertInDownloading(true)

    const frontPage1 = reportAppName(certInApplicationName)
    const frontPage2 = auditReportTable(certInDate, certInStartDate, certInEndDate)

    const page21 = page2Heading
    const page211 = documentPreparation(certInDate, certInApplicationName)
    const page212 = documentHistory(certInDate)
    const page213 = documentDistribution(inchargeDesignation, inchargeEmail, inchargeName, certInCustomerName)

    const page3 = TOCHeadings

    const page41 = introductionText1(certInApplicationName)
    const page411 = introductionBulletOne(certInApplicationName)
    const page412 = introductionBulletTwo
    const page413 = introductionBulletThree

    const page5 = scope(certInApplicationUrl, certInAppDescription, criticality)

    const page6 = team

    const page7 = auditActivities
    const page71 = auditActivities1
    const page711 = auditPoint1
    const page712 = auditPoint2
    const page713 = auditPoint3
    const page714 = auditPoint4
    const page715 = auditPoint5
    const page716 = auditPoint6
    const page717 = auditPoint7
    const page718 = auditPoint8
    const page719 = auditPoint9
    const page72 = timelines
    const page721 = timeline1(certInStartDate, certInEndDate)

    const page81 = auditMethodology(certInCustomerName, certInApplicationName)
    const page811 = Methodology
    const page812 = accrualPhase
    const page813 = accrualPhaseText
    const page814 = accrualPhasebullet1
    const page815 = accrualPhasebullet2
    const page816 = accrualPhasebullet3
    const page82 = acclimatizePhase
    const page821 = acclimatizePhaseText
    const page83 = analysisPhase
    const page831 = analysisPhaseText
    const page84 = admittancePhase
    const page841 = admittancePhaseText
    const page85 = affirmationPhase
    const page851 = affirmationPhaseText

    const page9 = tools

    const page101 = summaryText(certInCustomerName, certInApplicationName)
    const page102 = summaryText1
    const page1021 = sumaryText2(certInAppEnvironment, certInTestingype)
    const page1022 = summaryUserRoles(certInRoles)
    const page103 = SummaryRecommendation
    const page1031 = recommendationBulletOne
    const page1032 = recommendationBulletTwo
    const page104 = determination
    const page1041 = determination1
    const page1042 = determination2
    const page105 = cvssMapping
    const page1051 = cvssMappingTable
    const page106 = riskRating
    const page1061 = riskRatingTable
    const page107 = exploitation
    const page1071 = exploitationTable
    const page108 = graphText
    const page1081 = tableText
    const page1082 = severityLevelTable(certInCritical, certInHigh, certInMedium, certInLow, certInInfo)
    const page109 = graphText1
    const page1010 = vulnerabilityTables

    const page111 = observation1
    const page112 = observation2
    const page113 = observation3

    const page121 = complianceTable

    const page131 = auditTools
    const page132 = appendicesTable

    const design = {
        page: {
            margin: { top: 500, right: 700, left: 750, header: 870, footer: 850 },
            // size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }

    const heading1 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400, },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Introduction",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading2 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Engagement Scope",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading3 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Details of the Auditing team",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading4 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Audit Activities and Timelines",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading5 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Audit Methodology and Criteria / Standard referred for audit",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading6 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Tools/ Software used",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading7 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Executive Summary",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading8 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Detailed Observation",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading9 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methods of verification to compliance with CERT-In Directions",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading10 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Appendices",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    // OverView of findings
    const rows = [
        new TableRow({
            height: { value: 3000, rule: HeightRule.EXACT },
            children: [
                new TableCell({
                    width: { size: 600, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Affected Asset i.e. IP/URL/Application etc.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Observation/Vulnerability title",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 800, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "CVE/CWE",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT,
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 2500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1200, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Reference",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "New or Repeat observation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ],
        }),
    ];
    const sortVulnerabilities = certInVulnerabilities.sort((a, b) => b.risk - a.risk);

    sortVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(riskScore) {
            let severity = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "CRITICAL";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "HIGH";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "MEDIUM";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "LOW";
            } else {
                severity = "INFO";
            }

            return { severity };
        }

        const riskScore = vulnerability.risk;
        const { severity } = getSeverityAndColor(riskScore);
        rows.push(
            new TableRow({

                children: [
                    new TableCell({
                        width: { size: 600, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1700, type: WidthType.DXA },
                        children: vulnerability.uRLAddress.split(/\s+/).map((url) =>
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: url,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ),
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1500, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerability,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `CWE - ${vulnerability.cwe}`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],


                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 200, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 140, right: 140, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 2700, type: WidthType.DXA },
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 550, right: 50, top: 50, bottom: 50 },
                                    bullet: { level: 0 },
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Arial",
                                            size: 22,
                                            color: "000000",
                                            bold: false,
                                        }),
                                    ],
                                }),
                            )

                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1300, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: vulnerability.reference.split(/\s+/).map((url) =>
                                    new TextRun({
                                        text: url,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ),
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: "New",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ],
            }),
        )
    })

    // POC Related
    let clientImageRun;
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            return new ImageRun({
                data: imageData,
                transformation: { width: 670, height: 300 },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // VulnerabilityTable
    const sortedVulnerabilities = certInVulnerabilities.sort((a, b) => b.risk - a.risk);

    const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];
        for (const poc of vulnerability.poc) {
            combinedContent.push(new Paragraph({
                children: [
                    new TextRun({
                        text: poc.pocDesc,
                        size: 24,
                        italics: false,
                        bold: false
                    }),
                ],
            }));

            if (poc.files && poc.files.length > 0) {
                for (const file of poc.files) {
                    try {
                        const imageRun = await createImageRun(file);
                        combinedContent.push(new Paragraph({
                            spacing: { before: 200, after: 600 },
                            children: [imageRun],
                        }));
                    } catch (error) {
                        console.error('Error while uploading POC image:', error);
                    }
                }

            } else if (poc.pocImageURL) {
                try {
                    const pocImageData = await fetchImageAsBase64(poc.pocImageURL);
                    const imageRun = new ImageRun({
                        data: pocImageData.split(',')[1],
                        transformation: { width: 670, height: 300 }
                    });
                    combinedContent.push(new Paragraph({
                        spacing: { before: 200, after: 600 },
                        children: [imageRun],
                    }));
                } catch (error) {
                    console.error('Error while fetching PoC image from URL:', error);
                }
            }
        }

        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Information";
                color = "00b050";
            }

            return { severity, color };
        }

        const riskScore = vulnerability.risk;
        const { severity, color } = getSeverityAndColor(riskScore);

        return [
            new Paragraph({ pageBreakBefore: true }),
            new Paragraph({

                heading: HeadingLevel.HEADING_1,
                tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
                indent: { left: 500 },
                spacing: { after: 300 },
                numbering: { reference: "my-crazy-numbering", level: 1 },
                children: [
                    new TextRun({
                        text: vulnerability.vulnerability,
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false
                    })
                ],
            }),

            new Table({
                width: { size: 10300, type: WidthType.DXA },
                alignment: AlignmentType.CENTER,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({

                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected Asset",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.uRLAddress.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 80, after: 50 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: url,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ),
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Observation/ Vulnerability Title",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerability,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Detailed Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.description,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVE/CWE",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: `CWE - ${vulnerability.cwe}`,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Objective",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Name",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Audit Requirement",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Ease of Exploitation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.exploitation,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS String",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },

                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: vulnerability.cvss,
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            }),
                                        ]
                                    }),
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS Score/ Risk Rating",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: `${riskScore}/${severity}`,
                                            font: "Arial",
                                            size: 24,
                                            color: color,
                                            italics: false,
                                            bold: true,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is Recommended to:",
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            spacing: { before: 50, after: 50 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 700, right: 100 },
                                            bullet: { level: 0 },
                                            children: [new TextRun({
                                                text: bulletText.trim(),
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                            ]
                                        })
                                    )
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.reference.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: url,
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                        ]
                                    })
                                ),

                                borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            },
                            }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 2100, type: WidthType.DXA },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [new TextRun({
                                    text: "New or Repeat Observation",
                                    font: "Arial",
                                    size: 24,
                                    color: "ffffff",
                                    bold: false,
                                    italics: false
                                })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 8200, type: WidthType.DXA },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 150, after: 150 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [new TextRun({
                                    text: "New",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false,
                                })
                                ]
                            })
                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),
        ]
    }),

    new Paragraph({ pageBreakBefore: true }),
        new Paragraph({
            spacing: { line: 356, before:150 },
            children: [
                new TextRun({
                    text: "Proof of Concept",
                    size: 24,
                    color: "000000",
                    font: "Arial",
                    bold: true,
                    italics: false

                })
            ],
        }),

            ...combinedContent
        ]
})
const docSectionsResolved = await Promise.all(docSections);


const doc = new Document({
    creator: "manjesh",
    features: { updateFields: true },
    numbering: {
        config: [
            {
                reference: "my-crazy-numbering",
                levels: [
                    {
                        level: 0,
                        format: LevelFormat.DECIMAL,
                        text: "%1.",
                        alignment: AlignmentType.RIGHT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                            },
                            run: {
                                size: 40,
                                bold: true,
                                color: "2F5496",
                            },
                        },
                    },
                    {
                        level: 1,
                        format: LevelFormat.DECIMAL,
                        text: "8.%2",
                        alignment: AlignmentType.RIGHT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                            },
                            text: { color: "000000", bold: true, size: 24, font: "Arial" },
                            run: {
                                size: 24,
                                bold: true,
                                color: "000000",
                                font: "Arial"
                            },
                        },
                    },

                ]
            }
        ]
    },
    styles: {
        default: {

            document: {
                run: {
                    font: "Arial",
                    bold: true,
                    size: 24,
                    color: "000000",
                },
            },
            heading1: {
                run: {

                    font: "Arial",
                    bold: true,
                    italics: false,
                    allCaps: false
                },
                paragraph: { spacing: { line: 276 } },
            },
        },
    },
    sections: [
        {
            properties: { ...design },
            headers: {
                default: new Header({
                    children: [
                        new Table({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            alignment: AlignmentType.RIGHT,
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                            },
                            rows: [
                                new TableRow({
                                    children: [
                                        new TableCell({
                                            width: { size: 100, type: WidthType.PERCENTAGE },
                                            children: [
                                                new Paragraph({
                                                    alignment: AlignmentType.RIGHT,
                                                    children: [
                                                        new TextRun({
                                                            text: "<Confidential>",
                                                            size: 24,
                                                            font: "Arial",
                                                            color: '000000',
                                                            bold: false
                                                        })
                                                    ]
                                                })],
                                            borders: {
                                                top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                            },
                                        }),
                                    ]
                                })
                            ]
                        })
                    ]
                })
            },
            footers: {
                default: new Footer({
                    children: [
                        new Table({
                            margin: { top: 600 },
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            borders: {
                                top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            },
                            rows: [
                                new TableRow({
                                    children: [
                                        new TableCell({
                                            width: { size: 5, type: WidthType.PERCENTAGE },
                                            spacing: { before: 100 },
                                            children: [
                                                new Paragraph({
                                                    alignment: AlignmentType.LEFT,
                                                    children: [
                                                        new TextRun({
                                                            text: "Page",
                                                            italics: false,
                                                            font: "Calibri",
                                                            size: 24,
                                                            color: "002060",
                                                            bold: false
                                                        }),
                                                    ],
                                                }),
                                            ],
                                            borders: {
                                                top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                            },
                                        }),
                                        new TableCell({
                                            width: { size: 18, type: WidthType.PERCENTAGE },
                                            spacing: { before: 100 },
                                            children: [
                                                new Paragraph({
                                                    alignment: AlignmentType.LEFT,
                                                    children: [
                                                        new TextRun({
                                                            children: [PageNumber.CURRENT],
                                                            italics: false,
                                                            font: "Calibri",
                                                            size: 24,
                                                            color: "002060",
                                                            bold: false
                                                        }),

                                                        new TextRun({
                                                            text: " of ",
                                                            italics: false,
                                                            font: "Calibri",
                                                            size: 24,
                                                            color: "002060",
                                                            bold: false
                                                        }),

                                                        new TextRun({
                                                            children: [PageNumber.TOTAL_PAGES],
                                                            italics: false,
                                                            font: "Calibri",
                                                            size: 24,
                                                            color: "002060",
                                                            bold: false
                                                        }),
                                                    ],
                                                }),
                                            ],
                                            borders: {
                                                top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                            },
                                        }),

                                        new TableCell({
                                            width: { size: 77, type: WidthType.PERCENTAGE },
                                            spacing: { before: 100 },
                                            children: [
                                                new Paragraph({
                                                    indent: { right: 200 },
                                                    alignment: AlignmentType.RIGHT,
                                                    children: [
                                                        new TextRun({
                                                            text: "Cert-In Audit report format: Version 1.0",
                                                            font: "Calibri",
                                                            size: 24,
                                                            italics: false,
                                                            color: "002060",
                                                            bold: false
                                                        }),
                                                    ],
                                                }),
                                            ],
                                            borders: {
                                                top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                            },
                                        }),
                                    ]
                                })
                            ]

                        })
                    ]
                })
            },
            children: [frontPage1, frontPage2],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [page21, page211, new Paragraph({ spacing: { after: 600 }, }), page212, new Paragraph({ spacing: { after: 600 } }), page213],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [page3,
                new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    layout: TableLayoutType.FIXED,
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    alignment: AlignmentType.LEFT,
                    rows: [
                        new TableRow({

                            children: [
                                new TableCell({
                                    width: { size: 100, type: WidthType.PERCENTAGE },
                                    children: [
                                        new Paragraph({
                                            children: [
                                                new TableOfContents("Table of Content", {
                                                    hyperlink: true,
                                                    headingStyleRange: "1-5",
                                                }),
                                            ],
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    ],
                }),
            ],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading1, page41, page411, page412, page413],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading2, page5],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading3, page6],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading4, page7, page71, page711, page712, page713, page714, page715, page716, page717, page718, page719, page72, page721],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading5, page81, page811, page812, page813, page814, page815, page816, page82, page821,],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [page83, page831, page84, page841, page85, page851],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading6, page9],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading7, page101, page102, page1021, page1022, page103, page1031, page1032],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [page104, page1041, page1042, page105, page1051],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [page106, page1061, page107, page1071],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [page108, page1081, page1082, page109],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [new Paragraph({}),
            new Table({
                width: { size: 10335, type: WidthType.DXA },
                layout: TableLayoutType.FIXED,
                alignment: AlignmentType.CENTER,

                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                },
                rows: rows
            })
            ],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading8, page111, page112, page113],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [...docSectionsResolved.flat()],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading9, page121],
            pageBreakBefore: true,
        },
        {
            properties: { ...design },
            children: [heading10, page131, page132],
            pageBreakBefore: true,
        },

    ]
})

try {
    const response = await fetch(`${url}/reportdownload`, {
        method: 'POST',
        credentials: 'include'
    })
    if (response.ok) {
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, `Audit Report of ${certInApplicationName} Web Application.docx`);
        });
        setCertInDownloading(false)
        return
    }
    if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
} catch (error) {
    console.log(error)
    setCertInDownloading(false)
}
}
